import { ActionType, ProColumns } from '@ant-design/pro-components';
import { Checkbox, Form, Input, TablePaginationConfig, message } from 'antd';
import { ROUTES } from 'base/routes/routes';
import CustomButton from 'base/ui/components/Button';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus } from 'base/ui/components/Icons';
import CustomInputString from 'base/ui/components/Input/customInputString';
import usePartialState from 'hooks/usePartialState';
import { observer } from 'mobx-react';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DetailsContactSegmentModel } from 'services/Main/contactSegment_services';
import { contactSegmentPresenter, contactSegmentStore } from 'stores/root_store';
import { MVC_URL, PAGE_SIZE_DEFAULT } from 'utils/constants';
import { getPlantCode } from 'utils/localStorageHelper';

type AddContactSegmentProps = {
  onMoveTab: (targetKey: string) => void;
  tabID: string;
};

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
}

function AddContactSegment(props: AddContactSegmentProps) {
  const { t } = useTranslation();
  const { onMoveTab, tabID } = props;

  const [formCreate] = Form.useForm();

  const [searchParams] = useSearchParams();
  // lấy id
  const idContactSegment = searchParams.get('id');

  const navigate = useNavigate();



  // ============================================ LƯU MẪU BÁO CÁO =======================================================
  const tableRef = useRef<ActionType>();
  // ============================================ LẤY DROPDOWN ==========================================================
  const [selectedRowKeys, setSelectedRowKeys] = useState<(any)[]>([]);
  const [dataContactDetail, setDataContactDetail] = useState<DetailsContactSegmentModel[]>()

  const [loading, setLoading] = usePartialState({
    table: false,
    buttonSave: false
  })

  const [tableParams, setTableParams] = useState<SearchModel>({
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
    },
  });

  const handleSelect = (record: DetailsContactSegmentModel, selected: boolean) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.contactId]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.contactId);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) =>
      keys.length === dataContactDetail!.length ? [] : dataContactDetail!.map((r) => r.contactId)
    );
  };


  const initialColumns: ProColumns<DetailsContactSegmentModel>[] = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      align: 'center',
      width: 70
    },
    // Mã khách hàng
    {
      title: t('segment.ma-kh'),
      dataIndex: 'customerCode',
      key: 'customerCode',
      width: 120,
      align: 'center',
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.profileId}`} rel="noreferrer" >{text}</a>
      },
    },
    // Tên
    {
      title: t('segment.ten-kh'),
      dataIndex: 'customerName',
      key: 'customerName',
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.profileId}`} rel="noreferrer" >{text}</a>
      },
    },
    // Mã liên hệ (Mã CRM)
    {
      title: t('segment.ma-lienhe'),
      dataIndex: 'crmCode',
      key: 'crmCode',
      onCell: (_, index) => ({
        className: 'text-center',
      }),
      width: 100,
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.contactId}`} rel="noreferrer" >{text}</a>
      },
    },
    // Liên hệ (Khách hàng)
    {
      title: 'Liên hệ',
      dataIndex: 'profileName',
      key: 'profileName',
      render(text, record) {
        return <a target='_blank' href={`${MVC_URL}/Customer/Profile/Edit/${record.contactId}`} rel="noreferrer" >{text}</a>
      },
    },
    // Số điện thoại
    {
      title: t('segment.sdt'),
      dataIndex: 'phone',
      key: 'phone',
      width: 120
    },
    // Email
    {
      title: t('segment.email'),
      dataIndex: 'email',
      key: 'email',
    },
    //   Chi nhánh
    {
      title: t('segment.chi-nhanh'),
      dataIndex: 'branch',
      key: 'branch',
    },
    // Ghi chú
    // {
    //   title: 'Ghi chú',
    //   dataIndex: 'description',
    //   key: 'description',
    // },
    //   Người tạo
    {
      title: t('segment.nguoi-tao'),
      dataIndex: 'createBy',
      key: 'createBy',
    },
    //   Ngày tạo
    {
      title: t('segment.ngay-tao'),
      dataIndex: 'createTime',
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY HH:mm:ss',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Chăm sóc đặc biệt
    // {
    //   title:
    //     <div className='flex'>
    //       <div className='mr-2'>{t('segment.cs-db')}</div><Checkbox
    //         checked={!!selectedRowKeys.length}
    //         indeterminate={
    //           selectedRowKeys.length > 0 && selectedRowKeys.length < dataContactDetail!.length
    //         }
    //         onChange={toggleSelectAll}
    //       />
    //     </div>,
    //   dataIndex: 'csdb',
    //   width: 200,
    //   render: () => {
    //     return (<Checkbox></Checkbox>)
    //   },
    //   onCell: (_, index) => {
    //     return {
    //       style: {
    //         textAlign: 'center'
    //       }
    //     }
    //   }
    // },
    // Trạng thái
    {
      title: t('segment.trang-thai'),
      dataIndex: 'actived',
      key: 'actived',
      width: 100,
      render: (_, record) =>
        record.actived ? (
          <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
        ) : (
          <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
        ),
    },
  ];

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = 'Bạn có chắc muốn rời khỏi trang? Dữ liệu chưa được lưu.';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // ==================================================================================================

  // CALL API LẤY ID TỪ PARAM ĐỂ LẤY DATA PASS VÀO TABLE =================================================================
  const getContactSegment = async () => {
    setLoading({ table: true })
    await contactSegmentPresenter.getContact(contactSegmentStore, idContactSegment ?? '')
    setDataContactDetail(contactSegmentStore.detailsContactSegment.data)

    setSelectedRowKeys(contactSegmentStore.detailsContactSegment.data?.map(item => item.contactId))



    setLoading({ table: false })
  }
  useEffect(() => {
    if (idContactSegment)
      getContactSegment()
  }, [idContactSegment])

  const onFinish = async (fieldValues: any) => {
    setLoading({ buttonSave: true })
    const tempt = { ...fieldValues }
    Object.assign(tempt, { profileIds: selectedRowKeys, combineId: idContactSegment, companyCode: getPlantCode() })
    await contactSegmentPresenter.createContactSegment(contactSegmentStore, tempt)
    if (contactSegmentStore.createContactSegment.isSuccess) {
      message.success(contactSegmentStore.createContactSegment.message)
    } else {
      message.error(contactSegmentStore.createContactSegment.message)
    }
    onMoveTab(tabID)
    setLoading({ buttonSave: false })
  }

  return (
    <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm [&_textarea:forcus]:!shadow-none">
      <SearchForm
        form={formCreate}
        onFinish={async (fieldValues) => {
          onFinish(fieldValues)
        }}
        column="col-3"
      >
        {/* Tên phân khúc */}
        <SearchItem
          label={'Contact segmentation'}
          name={'contactSegmentName'}
          rules={[{ required: true, message: t('message.required-field') }]}>
          <CustomInputString />
        </SearchItem>
        {/* Mô tả */}
        <SearchItem name={'description'} label={t('segment.mo-ta')} col2>
          <Input.TextArea rows={1} />
        </SearchItem>
      </SearchForm>

      {/* Table */}
      <CustomProTable<DetailsContactSegmentModel>
        bordered
        className='mt-5'
        columns={initialColumns}
        dataSource={dataContactDetail}
        handleResize={() => { }}
        actionRef={tableRef}
        rowKey="contactId"
        loading={loading.table}
        // tắt thông báo mỗi khi select 1 row
        tableAlertRender={false}
        toolBarRender={() => [
          <CustomButton
            loading={loading.buttonSave}
            onClick={() => {
              formCreate.submit();
              // onMoveTab(tabID)
              navigate('/Customer/ContactSegmentation')
            }}
            type="primary"
          >
            {t('btn.save')}
          </CustomButton>,
          <CustomButton
            loading={loading.buttonSave}
            onClick={() => {
              formCreate.submit();
            }}
            type="primary"
          >
            {t('btn.save-continue')}
          </CustomButton>
        ]}
        rowSelection={{
          // selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
          columnWidth: 150,
          columnTitle: <div className='flex gap-2'>
            <span>Chăm sóc đặc biệt</span>
            <Checkbox
              checked={!!(selectedRowKeys?.length || 0)}
              indeterminate={
                (selectedRowKeys.length | 0) > 0 && selectedRowKeys.length < dataContactDetail!.length
              }
              onChange={toggleSelectAll}
            />
          </div>,
          selectedRowKeys: selectedRowKeys,
          onSelect: handleSelect,

        }}

        scroll={{ x: 2300, y: 300 }}
        pagination={{
          ...tablePagination(tableParams, setTableParams),
          // total: customerSegmentStore.listCustomerSegment.paging?.totalCount,
        }}
        options={{ reload: true }}
      />
    </div>
  );
}

export default observer(AddContactSegment);
